var map = {
	"./router_artworkArchive.js": "tgcP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eD0P";


//////////////////
// WEBPACK FOOTER
// ./src/pages/artworkArchive router_artworkArchive\.js$
// module id = eD0P
// module chunks = 65